export enum MyCreatorsActionTypes {
  FETCH_REQUEST = 'my-creators/FETCH_REQUEST',
  FETCH_ERROR = 'my-creators/FETCH_ERROR',
  FETCH_SUCCESS = 'my-creators/FETCH_SUCCESS',
  FETCH_NEXT_SUCCESS = 'my-creators/FETCH_NEXT_SUCCESS',
  FETCH_NEXT_ERROR = 'my-creators/FETCH_NEXT_ERROR',
  FETCH_NEXT_REQUEST = 'my-creators/FETCH_NEXT_REQUEST',
}
